<template>
  <v-container fluid grid-list-md>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-toolbar>
            <v-toolbar-title></v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-default-footer>
              <template v-slot:item.durum="{ item }">
                <v-chip :color="ticketState(item.durum).color">
                  {{ ticketState(item.durum).message }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                        @click="ticketDetails(item.id)"
                        medium
                        v-text="'view_module'"></v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'Log',
  data: () => ({
    items: [],
    headers: [
      {
        text: 'Uye id',
        value: 'uyeid',
      },
      {
        text: 'Konu',
        value: 'konu',
      },
      {
        text: 'Oluşturulma Tarihi',
        value: 'tarih',
      },
      {
        text: 'Son Mesaj Tarihi',
        value: 'sontarih',
      },
      {
        text: 'Durum',
        value: 'durum',
      },
      {
        text: 'İşlemler',
        value: 'actions',
      },
    ],
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    ticketDetails(id) {
      this.$router.push({
        name: 'ticket.details',
        params: { id },
      }).catch((err) => {});
    },
    ticketState(state) {
      let stateMessage = '';
      let stateColor = '';
      if (state === 1) {
        stateMessage = 'Yeni Oluşturuldu!';
        stateColor = 'primary';
      } else if (state === 2) {
        stateMessage = 'Aktif';
        stateColor = 'success';
      } else {
        stateMessage = 'Pasif';
        stateColor = 'error';
      }

      return {
        message: stateMessage,
        color: stateColor,
      };
    },
  },
  computed: {
    ...mapFields(['user']),
  },
  created() {
    const route = 'show/ticket';
    this.send({ route })
      .then(async (res) => {
        this.items = await res.data.data;
        this.items.map((el) => {
          el.uyeid = this.user.name.charAt(0)
            .toUpperCase() + this.user.name.slice(1);
        });
      });
  },
};
</script>
